module.exports = __webpack_public_path__ + "img/report.91952be7.svg";